var map = {
	"./Affiliation/index.vue": [
		"07c1",
		"view-Affiliation-index-vue"
	],
	"./AssignmentDetail/index.vue": [
		"cc26",
		"view-AssignmentDetail-index-vue"
	],
	"./AssignmentReport/index.vue": [
		"c628",
		"view-AssignmentReport-index-vue"
	],
	"./AssignmentReport/pages/AssignmentNotCheckedTeacherList.vue": [
		"4b0f",
		"view-AssignmentReport-pages-AssignmentNotCheckedTeacherList-vue"
	],
	"./AssignmentReport/pages/DayWiseStudentAssigment.vue": [
		"876f",
		"view-AssignmentReport-pages-DayWiseStudentAssigment-vue"
	],
	"./Assignments/index.vue": [
		"9c33",
		"view-Assignments-index-vue~view-index-vue~view-learningMaterials-_components-index-vue",
		"view-Assignments-index-vue"
	],
	"./Attendance/index.vue": [
		"3ca6",
		"view-Attendance-index-vue~view-AttendanceReport-index-vue~view-academic-_components-Attendance-index-vue",
		"view-Attendance-index-vue"
	],
	"./AttendanceReport/index.vue": [
		"e7e8",
		"view-Attendance-index-vue~view-AttendanceReport-index-vue~view-academic-_components-Attendance-index-vue",
		"view-AttendanceReport-index-vue"
	],
	"./AttendanceReport/pages/absent-list.vue": [
		"f6b2",
		"view-AttendanceReport-pages-absent-list-vue"
	],
	"./AttendanceReport/pages/attendance-pending.vue": [
		"ea80",
		"view-AttendanceReport-pages-attendance-pending-vue"
	],
	"./AttendanceReport/pages/monthly.vue": [
		"0ed2",
		"view-AttendanceReport-pages-monthly-vue"
	],
	"./AttendanceReport/pages/yearly.vue": [
		"ccbe",
		"view-AttendanceReport-pages-yearly-vue"
	],
	"./Batch/index.vue": [
		"f64d",
		"view-Batch-index-vue"
	],
	"./Devices/index.vue": [
		"53a3",
		"view-Devices-index-vue"
	],
	"./Faculty/index.vue": [
		"46ef",
		"view-Faculty-index-vue"
	],
	"./Grades/index.vue": [
		"2ac3",
		"view-Grades-index-vue"
	],
	"./Level/index.vue": [
		"d15b",
		"view-Level-index-vue"
	],
	"./MigrateRoutines/index.vue": [
		"7117",
		"view-MigrateRoutines-index-vue"
	],
	"./OptGroup/bx.new.vue": [
		"8719",
		"view-OptGroup-bx-new-vue"
	],
	"./OptGroup/index.vue": [
		"fa81",
		"view-OptGroup-index-vue"
	],
	"./Program/index.vue": [
		"9523",
		"view-Program-index-vue"
	],
	"./QrLogs/index.vue": [
		"1ea3",
		"view-QrLogs-index-vue"
	],
	"./Remarks/index.vue": [
		"36cf",
		"view-Remarks-index-vue"
	],
	"./Routines/index.vue": [
		"e66d",
		"view-Routines-index-vue"
	],
	"./Sections/index.vue": [
		"c96a",
		"view-Sections-index-vue"
	],
	"./Sections/oldIndex.vue": [
		"a030",
		"view-Sections-oldIndex-vue"
	],
	"./StudentBehaviour/index.vue": [
		"363f",
		"view-StudentBehaviour-index-vue"
	],
	"./StudentBehaviourReport/index.vue": [
		"c82e",
		"view-StudentBehaviourReport-index-vue"
	],
	"./StudentBehaviourReport/summaryreport.vue": [
		"818d",
		"view-StudentBehaviourReport-summaryreport-vue"
	],
	"./StudentGroups/detail.vue": [
		"aa67",
		"view-StudentGroups-detail-vue"
	],
	"./StudentGroups/index.vue": [
		"ca1f",
		"view-StudentGroups-index-vue"
	],
	"./Subjects/index.vue": [
		"453d",
		"view-Subjects-index-vue"
	],
	"./Syllabus/index.vue": [
		"18f9",
		"view-Syllabus-index-vue"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "0637";
module.exports = webpackAsyncContext;